var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/icon/warning/warning.svg"),"alt":"warning"}}),_c('BaseText',{attrs:{"variant":"h6","color":"#151515"}},[_vm._v(_vm._s(_vm.title))]),_c('BaseText',{attrs:{"color":"#333332"}},[_vm._v(_vm._s(_vm.content))])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }